const rearrangeContacts = () => {
	let i = 0
	if (window.innerWidth > 540 && window.innerWidth < 1000) {
		document.querySelectorAll('.kontakt').forEach(k => {
			k.classList.remove('left')
			k.classList.remove('right')
			if(i % 2 === 0){ k.classList.add('right')}
			else { k.classList.add('left') }
			i++
		})
	}
}

if (document.querySelector('.kontakt')) {
	// document.addEventListener('DOMContentLoaded', rearrangeContacts)
	// window.addEventListener('resize', rearrangeContacts)
}
